<template>
  <div class="flex flex-col gap-[40px]" :key="Math.floor(Math.random(10000))">
    <div v-for="(resource, i) in getSortedResources" :key="i">
      <h6 v-if="resource.sessionId" class="text-base font-aktiv-grotesk">
        Session {{ resource.sessionId }}:
      </h6>
      <h1
        class="mb-[16px] font-aktiv-grotesk text-[24px] leading-[32px] font-bold"
      >
        {{ resource.name }}
      </h1>
      <ResourcesSlider
        :category-index="Math.floor(Math.random(10000))"
        :items="resource.resources"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ResourcesSlider from "@/components/ResourcesPage/PlaybackResources/ResourcesSlider.vue";

export default {
  components: {
    ResourcesSlider,
  },
  props: {
    filteredResources: {
      type: Object,
    },
  },
  computed: {
    ...mapState("filter", ["scheduleMapping", "schedule"]),

    getSortedResources() {
      const results = [];
      for (const key in this.filteredResources) {
        const result = {
          sessionId: key,
          name: this.filteredResources[key].name,
          resources: this.filteredResources[key].resources,
        };
        results.push(result);
      }
      return results;
    },
  },
};
</script>
